import styled from 'styled-components'

import Icon from '../../../atoms/Icon'
import ToggleButton from '../../../atoms/ToggleButton'

export const Container = styled.div``

export const Button = styled(ToggleButton)``

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.textMedium}
  color: red;
  margin-top: 0.5rem;
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.textSmall}
  color: grey;
  margin-top: 0.5rem;
`

export const StyledIcon = styled(Icon)``
